/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Line_Up_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Move up one line" |
*
* @param {Position_Line_Up_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_line_up_aria_label = /** @type {((inputs?: Position_Line_Up_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Line_Up_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Monter d'une ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Zeile nach oben rücken")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spostati su di una riga")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместитесь на одну строку вверх")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subir una línea")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向上移动一行")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1行上に移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक पंक्ति ऊपर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Suba uma linha")
	return /** @type {LocalizedString} */ ("Move up one line")
});